import { useState, useEffect } from "react";

export const useDispatchLogic = ({ requestId, request, onConfirm }) => {
  const [driverName, setDriverName] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [description, setDescription] = useState("");
  const [wayBillNo, setWayBillNo] = useState("");
  const [amount, setAmount] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [documentNo, setDocumentNo] = useState("");

  // Address fields
  const [officeAddress, setOfficeAddress] = useState("");
  const [shipToAddress, setShipToAddress] = useState("");
  const [billToAddress, setBillToAddress] = useState("");
  const [sameAsShipTo, setSameAsShipTo] = useState(true);

  // New states for the items table
  const [items, setItems] = useState([{ id: Date.now(), description: "", hsnCode: "", quantity: 1, price: 0 }]);
  const [cgstRate, setCgstRate] = useState(9);
  const [sgstRate, setSgstRate] = useState(9);

  // Calculations
  const subTotal = items.reduce((acc, item) => acc + (Number(item.quantity) * Number(item.price)), 0);
  const cgstAmount = (subTotal * Number(cgstRate)) / 100;
  const sgstAmount = (subTotal * Number(sgstRate)) / 100;
  const grandTotal = subTotal + cgstAmount + sgstAmount;

  // Auto-sync calculated grand total to the amount field
  useEffect(() => {
    if (grandTotal > 0) {
      setAmount(grandTotal.toFixed(2));
    }
  }, [grandTotal]);

  // Pre-fill ship-to address from request's project when modal opens
  useEffect(() => {
    if (request) {
      const addr =
        request.projectDetails?.address ||
        request.projectDetails?.location ||
        request.project?.address ||
        "";
      setShipToAddress(addr);
      if (sameAsShipTo) setBillToAddress(addr);
    }
  }, [request]);

  // Keep billToAddress synced when sameAsShipTo is toggled on
  useEffect(() => {
    if (sameAsShipTo) setBillToAddress(shipToAddress);
  }, [sameAsShipTo, shipToAddress]);

  const handleAddItem = () => {
    setItems([...items, { id: Date.now(), description: "", hsnCode: "", quantity: 1, price: 0 }]);
  };

  const handleRemoveItem = (id) => {
    if (items.length > 1) {
      setItems(items.filter(item => item.id !== id));
    }
  };

  const handleItemChange = (id, field, value) => {
    setItems(items.map(item => item.id === id ? { ...item, [field]: value } : item));
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    if (!driverName || !vehicleNo) return;
    
    if (onConfirm) {
      const packedNotes = JSON.stringify({
        notes: description,
        wayBillNo,
        documentNo,
        invoiceNo,
        shipToAddress,
        billToAddress: sameAsShipTo ? shipToAddress : billToAddress,
        items,
        cgstRate,
        sgstRate,
        subTotal,
        cgstAmount,
        sgstAmount,
        grandTotal
      });

      onConfirm(requestId, {
        status: "dispatched",
        dispatchDetails: {
          driverName,
          vehicleNumber: vehicleNo,
          notes: packedNotes,
          wayBillNo,
          invoiceNo,
          documentNo,
          shipToAddress,
          billToAddress: sameAsShipTo ? shipToAddress : billToAddress,
        }
      });
    }
    
    // Reset form
    setDriverName("");
    setVehicleNo("");
    setWayBillNo("");
    setAmount("");
    setDescription("");
    setInvoiceNo("");
    setDocumentNo("");
    setShipToAddress("");
    setBillToAddress("");
    setSameAsShipTo(true);
    setItems([{ id: Date.now(), description: "", hsnCode: "", quantity: 1, price: 0 }]);
    setCgstRate(9);
    setSgstRate(9);
  };

  return {
    driverName, setDriverName,
    vehicleNo, setVehicleNo,
    description, setDescription,
    wayBillNo, setWayBillNo,
    amount, setAmount,
    invoiceNo, setInvoiceNo,
    documentNo, setDocumentNo,
    officeAddress, setOfficeAddress,
    shipToAddress, setShipToAddress,
    billToAddress, setBillToAddress,
    sameAsShipTo, setSameAsShipTo,
    items, handleAddItem, handleRemoveItem, handleItemChange,
    cgstRate, setCgstRate,
    sgstRate, setSgstRate,
    subTotal, cgstAmount, sgstAmount, grandTotal,
    handleSubmit
  };
};